import { AxiosResponse } from 'axios';
import { SET_ZMANIMS, SET_ZMANIM, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_ZMANIM_ISLOADING,
  DELETE_ZMANIM,
  EDIT_ZMANIM,
  GET_ZMANIMS,
  REGISTER_ZMANIM,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Zmanim from '@/services/zmanim';
import { Module } from 'vuex';
import { EditZmanim, RegisterZmanim, GetZmanim } from '@/dtos/zmanim.dto';

const zmanim: Module<any, {}> = {
  state: {
    zmanim: {
      data: null,
      isLoading: false,
    },
    zmanims: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    zmanim: (state: { zmanim: any }) => state.zmanim,
    zmanims: (state: { zmanims: any }) => state.zmanims,
  },
  mutations: {
    [SET_ZMANIM]: (
      state: { zmanim: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.zmanim.data = payload.data) : null,
        (state.zmanim.isLoading = payload.isLoading);
    },
    [SET_ZMANIMS]: (
      state: { zmanims: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.zmanims.data = payload.data) : null,
        (state.zmanims.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_ZMANIM]: async ({ commit }: any, payload: any) => {
      commit(SET_ZMANIM, { data: null, isLoading: true });

      const result: AxiosResponse = await Zmanim.registerZmanim(
        payload as RegisterZmanim
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ZMANIM, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM, { isLoading: false });
        return false;
      }
    },
    [GET_ZMANIMS]: async ({ commit }: any, payload: any) => {
      commit(SET_ZMANIMS, { data: null, isLoading: true });

      const result: AxiosResponse = await Zmanim.getZmanims(
        payload as GetZmanim
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ZMANIMS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIMS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIMS, { isLoading: false });
        return false;
      }
    },
    [EDIT_ZMANIM]: async ({ commit }: any, payload: any) => {
      commit(SET_ZMANIM, { data: null, isLoading: true });

      const result: AxiosResponse = await Zmanim.editZmanim(
        payload as EditZmanim
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ZMANIM, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM, { isLoading: false });
        return false;
      }
    },
    [DELETE_ZMANIM]: async ({ commit }: any, payload: string) => {
      commit(SET_ZMANIM, { data: null, isLoading: true });

      const result: AxiosResponse = await Zmanim.deleteZmanim(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ZMANIM, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ZMANIM, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ZMANIM, { isLoading: false });
        return false;
      }
    },
    [CLEAR_ZMANIM_ISLOADING]: ({ commit }) => {
      commit(SET_ZMANIM, { isLoading: false });
      commit(SET_ZMANIMS, { isLoading: false });
    },
  },
};

export default zmanim;
